<template>
  <div>
    <div class="header">
      <div class="buttons">
        <a @click="$router.go(-1)" class="back">
          <vk-icon icon="triangle-left" ratio="2"></vk-icon>
        </a>
        <span>{{ title }}</span>
      </div>
    </div>
    <div class="body" v-html="body">
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'Order',
    components: {
    },
    data () {
      return {
        title: '',
        body: ''
      };
    },
    created () {
      this.fetch();
    },
    computed: {
    },
    methods: {
      async fetch () {
        this.$store.commit('setLoading');
        let response = await axios.get('http://admin.harigu.com/api/contents/' + this.$route.params.code);
        this.title = response.data.title;
        this.body = response.data.body;
        this.$store.commit('resetLoading');
      }
    },
    watch: {
      '$route' () {
        this.fetch();
      }
    }
  };
</script>

<style scoped lang="scss">
  .header {
    position: sticky;
    position: -webkit-sticky;
    top: 48px;
    z-index:999;
  }
  .buttons {
    background-color: rgb(128, 127, 128);
    color: #fff;
    font-weight: bold;
    overflow: hidden;

    .back {
      color: rgb(240, 240, 240) !important;
      float: left;
      display: block;
    }

    span {
      float: right;
      display: block;
      padding-right: 10px;
      line-height: 40px;
      height: 40px;
    }

    &:after {
      clear: both;
    }
  }
  .body {
    padding: 1rem;
  }
</style>
